module.exports = __webpack_public_path__ + "img/exam_jan_2025_7zm0bklu.0560869a.jpg";